import psl_ui from '../../libs/psl_ui.js';
import template from './template.pst';

import state from '../../state.js';

import './style.scss';

import path from '../../path.js';

psl_ui.templates.add('page_outro_billboard',template);

const {el,rpoints}=psl_ui.templates.render('page_outro_billboard');

let _clb;

rpoints.button.addEventListener('click',()=>{
	_ext.hide();
	if(_clb) _clb();
});

window.addEventListener('resize',()=>{
	if(!el.parentNode) return;
	_resize();
});

function _resize(){
	let width=window.innerWidth;
	let height=window.innerHeight;
	let coef = 1;

	if(width>height){
		width=width/1920;
		height=height/1080;
	} else {
		width=width/1080;
		height=height/1920;
	}

	coef = Math.min(width,height);

	rpoints.container.style.transform=`scale3d(${coef},${coef},1)`;
}

rpoints.print.addEventListener('click',()=>{
	window.print();
});

const _render_banner = (choices) => {
	rpoints.bkg.src=`${path()}img/billboard/${choices.bkg}_bkg.jpg`;
	rpoints.label.src=`${path()}img/billboard/${choices.label}_label.png`;
	rpoints.img.src=`${path()}img/billboard/${choices.img}_img.png`;

	rpoints.banner.setAttribute('aria-label',choices.msg);
}

const _ext={
	show:({
		header,
		desc,
		clb,
		parent,
		cls = '',
		choices
	})=>{
		el.className=`page outro car_${state.car} ${cls}`;
		rpoints.header.innerHTML=header;
		rpoints.desc.innerHTML=`<p>${desc.join('</p><p>')}</p>`;
		_clb=clb;
		_render_banner(choices);
		parent.insertBefore(el,parent.firstChild);
		_resize();
		rpoints.header.focus();
	},
	hide:()=>{
		if(el.parentNode) el.parentNode.removeChild(el);
	}
}

export default _ext;
